import React from 'react';
import { CardBody } from '../../components/CardBody';
import { CardFooter } from '../../components/CardFooter';
import { CardTitle } from '../../components/CardTitle';
import { assetPathFn, sizeImage } from '../../util';
import { LanderTopHero } from '../components/LanderTopHero';
import styles from './SustainabilityLander.module.scss';

export const SustainabilityLanderMobile: React.FC = () => {
  return (
    <>
      <CardBody>
        <LanderTopHero
          heroImage={'sustainability-top-hero-mobile.jpg'}
          titleElement={<div style={{ color: 'white', fontSize: '32px', position: 'absolute', top: '54vw', left: 0, right: 0 }}>Made with intention</div>}
          title={'Made with intention'}
          heroContainerHeight={'auto'}
        ></LanderTopHero>
        <CardTitle
          style={{
            fontFamily: 'GTAmerica',
            fontSize: '26px',
            lineHeight: '38px',
            letterSpacing: '.5px',
            marginTop: -40,
          }}
          text={
            <>
              Our goal is to create <br />
              products you’ll love for a <br />
              lifetime — not throw in a <br /> landfill. Here’s what we’re <br />
              doing to minimize our <br />
              environmental impact.
            </>
          }
        />
        <div className={styles.promoWrapper}>
          <img src={assetPathFn(sizeImage('sustainability-greenhouse-gas.jpg', '800x'))} alt="Reducing greenhouse gas emissions" />
          <div>
            <div className={styles.promoTitle}>Reducing greenhouse gas emissions</div>
            <div>
              As of 2021, we offset our annual CO₂ emissions for all imported product transportation through our partnership with the Carbonfund.org Foundation.
              In 2021, we offset 554.75 tonnes of carbon. This is equal to carbon absorbed by 656.40 acres of forest over one year. 
            </div>
          </div>
        </div>
        <div className={styles.promoWrapper} style={{ marginTop: 20 }}>
          <img src={assetPathFn(sizeImage('sustainability-recycling.jpg', '800x'))} alt="A commitment to recycling" />
          <div>
            <div className={styles.promoTitle}>A commitment to recycling</div>
            <div>
              We utilize the Terracycle zero waste program to recycle fabric scraps from our in-house sample room and garments that can't be donated or sold.
              All material sent to Terracycle will be shredded and used for insulation and padding, giving them a second life and keeping them out of the
              landfill.
            </div>
          </div>
        </div>
        <div className={styles.greyPromoWrapper}>
          <img src={assetPathFn(sizeImage('sustainability-anti-mobile.jpg', '800x'))} alt="anti-fast fashion" />
          <div>
            <div className={styles.greyPromoTitle}>ANTI-FAST FASHION</div>
            <div>
              Quality is our number one priority. Each Honeylove product is made with durable fabric that keeps its shape and reinforced seaming that won’t fall
              apart. We also work hard to create timeless, trend-less pieces that you’ll be excited to wear for years.
            </div>
          </div>
        </div>
        <div className={styles.iconWrapper}>
          <div>
            <img src={assetPathFn('biodegradable-icon.png')} alt="Less packaging waste" />
            <div className={styles.iconTitle}>Less packaging waste</div>
            <div>We use biodegradable mailers instead of a box whenever possible. In 2022, we are upgraded to include recycled hang tags and poly bags.</div>
          </div>
          <div>
            <img src={assetPathFn('efficient-icon.png')} alt="More efficient sampling" />
            <div className={styles.iconTitle}>More efficient sampling</div>
            <div>By committing to domestic research and product development, we’re able to drastically reduce the waste created by overseas sampling.</div>
          </div>
          <div>
            <img src={assetPathFn('testing-icon.png')} alt="Rigorous testing" />
            <div className={styles.iconTitle}>Rigorous testing</div>
            <div>
              An extensive wear testing and customer surveying process ensures each product meets our quality standards to minimize returns and extend product
              life.
            </div>
          </div>
        </div>
        <div className={styles.greyPromoWrapper} style={{ backgroundColor: '#e1e1e1', marginBottom: 60 }}>
          <img src={assetPathFn(sizeImage('sustainability-giving-back-mobile.jpg', '800x'))} alt="giving back" style={{ maxWidth: 800 }} />
          <div>
            <div className={styles.greyPromoTitle}>Giving back</div>
            <div>
              Products in excellent condition that cannot be resold are donated to organizations like I Support the Girls and Dress for Success to give
              underserved women access to Honeylove garments and avoid unnecessary waste. In 2021 we donated $1 million worth of bras, tops, and shapewear to I
              Support the Girls. 
            </div>
          </div>
        </div>
      </CardBody>
      <CardFooter />
    </>
  );
};

export default SustainabilityLanderMobile;
